import React, { Component } from 'react';
import NavBar from "../NavBar.js";
import Footer from "../Footer.js";
import Web3 from 'web3';
import standard_abiA from '../../abis/Standard16A-abi.json';
import standard_abiB from '../../abis/Standard16B-abi.json';
import UserCertificateList from './UserCertificateList.js';
import { properties } from '../properties.js';
import i18n from '../I18N/I18n.js'; 
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import './css_16/userCertificate.css';
import '../css/navBar.css';
import { loadWeb3, logout, apiSecuredRequest, isUserOrWallet, setBearer, cargarIdiomaPreferido} from '../functions.js';


class CertificadosUsuario extends Component {

	async componentDidMount() {
		await cargarIdiomaPreferido(this.cambiarIdioma);
		// 1. Carga de Web3
		const {bearerVar, certificadoId, account} =  await this.checkIfWeb3UserOrLoginUser();
		await this.loadPageNumbers(account);
		// 2. Carga de datos de la Blockchain
		
		await this.cargarPasaportesCertificado(bearerVar, 0, certificadoId);
		// 3. Carga los nfts del usuario
	}


	cambiarIdioma = (idioma) => {
		const { i18n } = this.props;
		i18n.changeLanguage(idioma); 
		this.forceUpdate(); 
		Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
	  };

    logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
    }

	async checkIfWeb3UserOrLoginUser(){
        let params = (new URL(document.location)).searchParams;
        const certificadoId = params.get("certificadoId");
        this.setState({ certificadoId: certificadoId })
        const certificadoName = params.get("certificadoName");
        this.setState({certificadoName})
        
        let empresaIdVar;
       
        let bearerVar;
        const urlInfo = window.location.pathname.split("/")
       
        this.setState({ empresaMapping: urlInfo[1] })
        const email = Cookies.get("email");
		const userId = Cookies.get("userId");
		this.setState({userId})
        this.setState({ email: email });
        bearerVar = Cookies.get("id");
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        
        let account = await isUserOrWallet(email, bearerVar);
		this.setState({account: account});
        const bearerToken = await setBearer(email, bearerVar, account);
        this.setState({bearer: bearerToken})
       
       

       
        return {bearerVar, certificadoId, account};
       
    }



	handlePageChange = (newPage) => {
		const { bearer } = this.state;
		this.cargarPasaportesCertificado(bearer, newPage, this.state.certificadoId);
	};

	loadPageNumbers = async (account) => {
		const pages = await this.generatePageNumbers(account);
		this.setState({ pageNumbers: pages });
	  };

	  generatePageNumbers = async (accountUser) => {
		const { pageSize, account } = this.state;
		let certificadosTotal = 0;
	  
		if (accountUser !== 0) {
			const abi = standard_abiA;
			const certificado = JSON.parse(localStorage.getItem('certificado'));
			const direccion = certificado.direccion;
					
			web3 = new Web3(window.ethereum);
			const contractA = new web3.eth.Contract(abi, direccion);
			this.setState({contract: contractA});
		  const userNfts = await contractA.methods
			.getTotalStandardDataCountByOwner()
			.call({ from: account });
	  
		  certificadosTotal = parseInt(userNfts, 10);
		} else {
		  const params = new URL(document.location).searchParams;
		  const certificadoId = params.get("certificadoId");
		  const userId = Cookies.get("userId");
		  const bearerVar = Cookies.get("id");
	  
		  const apiUserNfts = await apiSecuredRequest(
			"get",
			`${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndCertificadoId/${userId}/${certificadoId}`,
			"",
			bearerVar
		  );
	  
		  certificadosTotal = parseInt(apiUserNfts.data, 10);
		}
	  
		// Guardamos certificadosTotal una vez aquí
		this.setState({ certificadosTotal });
	  
		const totalPages = Math.ceil(certificadosTotal / pageSize);
		return Array.from({ length: totalPages }, (_, i) => i);
	  };


	async cargarPasaportesCertificado(bearer, page, certificadoId) {
		
		
       
       
		this.setState({certificadoId: certificadoId});
		let userNfts;
		let balance;
		let userId;
		userId = Cookies.get("userId");
		const abi = standard_abiA;
		const certificado = JSON.parse(localStorage.getItem('certificado'));
		const direccion = certificado.direccion;
				
		web3 = new Web3(window.ethereum);
		const contractA = new web3.eth.Contract(abi, direccion);
		this.setState({contract: contractA});
		if(this.state.account != 0) {
			
			userNfts = await contractA.methods.getOwnerProductDataPaginated(page, this.state.pageSize).call({ from: this.state.account });
			this.setState({certificados: userNfts});


		}else{

			const apiUserNfts = await apiSecuredRequest("get", `${properties.apiUrl}/certificat/api/standardData/standardInfo/getByUseridAndCertificadoId/${userId}/${certificadoId}/16/${page}/${this.state.pageSize}`, "", bearer);
			let certificate;
			this.setState({ dataBaseNfts: apiUserNfts.data })

					
					let userNfts = []
					for (let x = 0; x < apiUserNfts.data.length; x++) {
						certificate = await contractA.methods.getCertificateByIdProducto(apiUserNfts.data[x].idProducto).call({ from: properties.contractOwner });


									userNfts.push(certificate);


						

					}
					this.setState({certificados: userNfts});	

		}



	

		
	  }


	// 1. Carga de Web3
	

	// 2. Carga de datos de la Blockchain
	async loadUserCertificates(bearer) {

		
		

	}

	constructor(props) {
		super(props)
		this.state = {
			account: '0x0',
			loading: true,
			contract: null,
			balance: null,
			userNfts: null,
			email: null,
			userId: null,
			bearer: null,
			certificadosTotal: 0,
			currentPage: 0,
			pageSize: 10,
			certificados: null,
			certificadoId: null,
			certificadoName: null,
			dataBapostgreNfts: null,
			empresaMapping: null,
			pageNumbers: []
		}
	}

	render() {
		

		return (
			<>
				<NavBar mail = {this.state.email} bearer = {this.state.bearer} logout = {this.logout} cambiarIdioma={this.cambiarIdioma}/>

				<main >

				<div className="buttonContainer">
					
						<button onClick={(event) => { window.location.href = `/listaEmpresas` }}  className="homePage_emailBtn" >{i18n.t('allBrands')}</button>
					
				</div>

				<h1 className="centeredTitle">{this.state.certificadoName}</h1>
					<UserCertificateList items={this.state.certificados} balance={this.state.certificadosTotal} contract={this.state.contract}
						mail={this.state.email} id={this.state.bearer} account={this.state.account} mapping = {this.state.empresaMapping} certificadoId ={this.state.certificadoId} certificadoName = {this.state.certificadoName} />
					 <div className="pagination-controls">
							<button
								onClick={() => this.handlePageChange(this.state.currentPage - 1)}
								disabled={this.state.currentPage === 0}
							>
								«
							</button>

							{this.state.pageNumbers.map((page) => (
								<button
								key={page}
								onClick={() => this.handlePageChange(page)}
								className={page === this.state.currentPage ? 'active-page' : ''}
								>
								{page + 1}
								</button>
							))}

							<button
								onClick={() => this.handlePageChange(this.state.currentPage + 1)}
								disabled={(this.state.currentPage + 1) * this.state.pageSize >= this.state.certificadosTotal}
							>
								»
							</button>
					</div>              
				</main>
				<Footer />

			</>

		);
	}
}

export default withTranslation()(CertificadosUsuario);
